// Frontend error handler utility
export const errorHandler = {
  // Common error messages
  messages: {
    DUPLICATE_ENTRY: 'Entry already exists for this combination',
    INVALID_IDS: 'Invalid client or resource ID provided',
    MISSING_FIELDS: 'Missing required fields',
    NOT_FOUND: 'Entry not found',
    DATABASE_ERROR: 'Database operation failed',
    VALIDATION_ERROR: 'Validation failed',
    UNAUTHORIZED: 'Unauthorized access',
    FORBIDDEN: 'Access forbidden',
    NETWORK_ERROR: 'Network connection error',
    UNKNOWN_ERROR: 'An unexpected error occurred'
  },

  // Extract error message from API response
  getErrorMessage(error) {
    if (!error) return this.messages.UNKNOWN_ERROR;

    // Handle axios error response
    if (error.response) {
      const { data, status } = error.response;
      
      // Check for specific error messages from backend
      if (data && data.error) {
        return data.error;
      }
      
      // Handle HTTP status codes
      switch (status) {
        case 400:
          return data?.details || this.messages.VALIDATION_ERROR;
        case 401:
          return this.messages.UNAUTHORIZED;
        case 403:
          return this.messages.FORBIDDEN;
        case 404:
          return this.messages.NOT_FOUND;
        case 409:
          return data?.error || this.messages.DUPLICATE_ENTRY;
        case 500:
          return data?.details || this.messages.DATABASE_ERROR;
        default:
          return data?.error || this.messages.UNKNOWN_ERROR;
      }
    }

    // Handle network errors
    if (error.request) {
      return this.messages.NETWORK_ERROR;
    }

    // Handle other errors
    return error.message || this.messages.UNKNOWN_ERROR;
  },

  // Get detailed error information
  getErrorDetails(error) {
    if (!error || !error.response) return null;
    
    const { data } = error.response;
    return data?.details || null;
  },

  // Format error for display
  formatError(error, context = '') {
    const message = this.getErrorMessage(error);
    const details = this.getErrorDetails(error);
    
    return {
      message: context ? `${context}: ${message}` : message,
      details,
      fullError: error
    };
  },

  // Handle specific error types
  handleDuplicateError(error) {
    const details = this.getErrorDetails(error);
    if (details && details.clientName && details.resourceName && details.monthYear) {
      return `Entry already exists for ${details.clientName} - ${details.resourceName} in ${details.monthYear}`;
    }
    return this.getErrorMessage(error);
  },

  handleValidationError(error) {
    const details = this.getErrorDetails(error);
    if (details && typeof details === 'string' && details.includes('Missing fields:')) {
      return details;
    }
    return this.getErrorMessage(error);
  }
};

export default errorHandler;
